import {PropsWithChildren} from 'react';
import {
  GuestSchemaContext,
  useGuestSchemaState,
  type GuestSchemaContextProps,
} from '@chekin/shared/guest-form';
import {useChekinSDK} from '../ChekinSDK';
import {useSummary} from '../summary';
import {useBrandingTheme} from '../brandingTheme';
import {toastResponseError} from 'utils/common';

export type {AddFormType} from '@chekin/shared/guest-form';
export type ContextProps = GuestSchemaContextProps;

const GuestContext = GuestSchemaContext;

const handleSchemaError = () =>
  toastResponseError(
    'Something went wrong while fetching guest fields schema. If the error persists, contact our support team.',
  );

function GuestProvider({children}: PropsWithChildren) {
  const {isSuccessSDK} = useChekinSDK();
  const {isTemplateInitialized} = useBrandingTheme();
  const {reservationId} = useSummary();

  const value = useGuestSchemaState({
    reservationId,
    enabled: Boolean(isSuccessSDK) && isTemplateInitialized,
    onSchemaError: handleSchemaError,
  });

  return (
    <GuestSchemaContext.Provider value={value}>{children}</GuestSchemaContext.Provider>
  );
}

export {GuestContext, GuestProvider};
